// extracted by mini-css-extract-plugin
export var productImage = "_k2-1";
export var viewLink = "_k2-2";
export var wishlistItem = "_k2-0";